import { styled } from 'styled-components'
import Illustration from 'mixtiles-web-common/elements/Illustration/Illustration'

export const SuccessIllustration = styled(Illustration)`
  width: 90px;
  height: 96px;
  margin: 35px 0 30px;
`

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.black};
`

export const Text = styled.div`
  color: ${({ theme }) => theme.colors.black};
`

export const Cta = styled.div`
  margin-bottom: 22px;
`
